// extracted by mini-css-extract-plugin
module.exports = {"page_promote":"Promote_page_promote__Bmutm","itemEmpty":"Promote_itemEmpty__1MqaG","fadeIn":"Promote_fadeIn__1AITC","scaleXin":"Promote_scaleXin__3RJld"};